import { useEffect, useState } from "react";
import { Download, Share, Plus, X } from "lucide-react";
import { Button } from "@/components/ui/button";

const isStandalone = () =>
  window.matchMedia("(display-mode: standalone)").matches || window.navigator.standalone === true;
const isIOS = () => /iphone|ipad|ipod/i.test(window.navigator.userAgent);

export function InstallAppButton() {
  const [deferred, setDeferred] = useState(null);
  const [showIOS, setShowIOS] = useState(false);
  const [installed, setInstalled] = useState(isStandalone());

  useEffect(() => {
    const onPrompt = (e) => { e.preventDefault(); setDeferred(e); };
    const onInstalled = () => { setInstalled(true); setDeferred(null); };
    window.addEventListener("beforeinstallprompt", onPrompt);
    window.addEventListener("appinstalled", onInstalled);
    return () => {
      window.removeEventListener("beforeinstallprompt", onPrompt);
      window.removeEventListener("appinstalled", onInstalled);
    };
  }, []);

  if (installed) return null;
  // Show on Android/desktop once the browser is ready, or always on iOS (manual steps).
  if (!deferred && !isIOS()) return null;

  async function install() {
    if (deferred) {
      deferred.prompt();
      await deferred.userChoice;
      setDeferred(null);
    } else {
      setShowIOS(true);
    }
  }

  return (
    <>
      <Button type="button" variant="outline" onClick={install} data-testid="install-app-btn"
        className="w-full rounded-full">
        <Download className="mr-2 h-4 w-4" /> Install Staff App
      </Button>

      {showIOS && (
        <div className="fixed inset-0 z-50 flex items-end justify-center bg-black/50 p-4" data-testid="ios-install-sheet"
          onClick={() => setShowIOS(false)}>
          <div className="w-full max-w-md rounded-2xl bg-card p-5 shadow-2xl" onClick={(e) => e.stopPropagation()}>
            <div className="mb-3 flex items-center justify-between">
              <h3 className="font-heading text-lg font-bold">Add to Home Screen</h3>
              <button onClick={() => setShowIOS(false)} data-testid="ios-install-close"><X className="h-5 w-5 text-muted-foreground" /></button>
            </div>
            <ol className="space-y-3 text-sm text-muted-foreground">
              <li className="flex items-center gap-2">1. Tap the <Share className="h-4 w-4 text-primary" /> <span className="font-medium text-foreground">Share</span> button in Safari.</li>
              <li className="flex items-center gap-2">2. Choose <Plus className="h-4 w-4 text-primary" /> <span className="font-medium text-foreground">Add to Home Screen</span>.</li>
              <li>3. Tap <span className="font-medium text-foreground">Add</span> — the Crystal Pharmacy staff app icon appears on your home screen.</li>
            </ol>
          </div>
        </div>
      )}
    </>
  );
}
